import React, { useState } from "react";
import Config from "../../config/Config";
import RightChart from "./com/chart/RightChart";
import Dagre from "./com/chart/Dagre";

import './detail.scss'

const source = Config.getSourcePath();
const ProfessionDetail = (props) =>
{

    const [info, setInfo] = useState(require(`./com/data/ruanjian/${'销售经理'}.js`).default ?? {});
    const [show, setShow] = useState(false);
    const [isHas, setIsHas] = useState(true);
    const [activeTab, setActiveTab] = useState(1);

    const { name } = props.location?.state || {}

    const addNewline = (text) => {
        return text.replace(/(.{25})/g, '$1\n');
    }

    const dealWithData = (arr) =>
    {
        let newArr = [];
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].children && arr[i].children.length > 0) {

                newArr.push({
                    label: addNewline(arr[i].label),
                    id: arr[i].id,
                    children: dealWithData(arr[i].children)
                })
            } else {
                
                newArr.push({
                    label: addNewline(arr[i].label),
                    id: arr[i].id,
                })
            }
        }
        return newArr;
    }

    const nodeClick = (node) =>
    {

        if (node && node.item && node.item._cfg.model)
        {
            let fileName = node.item._cfg.model.name;
            if (fileName == '财务总监/CFO') 
            {
                fileName = "财务总监CFO";
            } else if (fileName == '技术总监/CTO') {
                fileName = "技术总监";
            } else if (fileName == '技术专家/架构师/咨询顾问') {
                fileName = "技术专家";
            }

            if (fileName == '初入职场')
            {
                setIsHas(false);
                setShow(true);
                return false
            }
            
            let data = require(`./com/data/${name}/${fileName}.js`).default ?? {};
            console.log(data, '=========data');
            
            if (data && JSON.stringify(data) !== '{}') 
            {

                let newData = dealWithData([data], 'label')[0];
                setInfo(newData);
                setShow(true);
                setIsHas(true);
            } else {
                setInfo({});
                setIsHas(false);
                setShow(true);
            }
        }
    }

    const setTitle = (name) =>
    {
        switch (name)
        {
            case 'ruanjian':
                return '软件销售'
            case 'renli':
                return '人力资源管理'
            case 'caiwu':
                return '财务管理'
            case 'kaifa':
                return '开发程序员'
            case 'bianzhi':
                return '纺织设备技术员'
            case 'kuangshan':
                return '矿山工程职业发展规划'
        }
    }

    const tabList = [
        '<span>AI </span>解读',
        '职位晋升'
    ]

    return (
        <div component-data={source} className="profession-detail">
            <div className="profession-detail-chart">
                <div className="profession-left">
                    <div className="profession-detail-title">
                        <div className="profession_goback_btn" onClick={() => props.history.push('/home/profession')}>
                            <img src={require('../../img/enterprise/reback.png')} />
                        </div>
                        <span>{setTitle(name)}</span>
                    </div>
                    <Dagre nodeClick={nodeClick} location={props.location} />
                </div>
                <div className="profession-right">
                    <div className="profession-right-tab">
                        {
                            tabList.map((item, index) => {
                                return (
                                    <div dangerouslySetInnerHTML={{ __html: item }} key={index} className={index == activeTab ?"profession-right-tab-item profession-right-tab-active" : "profession-right-tab-item"} onClick={() =>setActiveTab(index)}></div>
                                )
                            })
                        }
                    </div>
                    {
                        activeTab == 1
                        ?   info && JSON.stringify(info) !== '{}' ? <RightChart info={info} /> : <div className="profession-right-nodate">暂无数据</div>
                        :   <div className="profession-right-nodate">暂无数据</div>
                    }
                </div>
            </div>
            
        </div>
    );
} 

export default ProfessionDetail;